import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {County} from '../../entity/model/county';

export default class CountyAgent {

  getCounties = async (): Promise<County[]> => {
    return await API.get(awsApiName, '/locations/counties', {});
  }

  getCountyByStateId = async (stateId: string): Promise<County[]> => {
    return await API.get(awsApiName, '/locations/counties', {
      queryStringParameters: {
        stateId: stateId
      }
    });
  }
}